export enum CarriersSortTypes {
  Asc = 'Asc',
  Desc = 'Desc',
  Updated = 'Updated',
}
